import * as React from 'react'
import styled from 'styled-components'
import {
  PropertyFieldWrapper,
  PropertyFieldInputWrapper,
  PropertyFieldLabel
} from './styles'

export const PropertyFieldInput = styled.textarea`
  width: auto !important;
  overflow: hidden;
  resize: none;
  text-align: right;
  outline: none;
  border: none;
  margin: 0;
  box-sizing: border-box;
  max-height: 100%;
  font-size: 12px;
  line-height: 32px;
  padding: 0;
`

export const StringInput = styled(PropertyFieldInput).attrs(
  ({ value }: { value: string }) => ({
    row: 1,
    cols: value?.length,
    wrap: 'off',
    autocapitalize: 'none',
    type: 'text',
    value
  })
)``

const TextInput = styled(PropertyFieldInput).attrs({})`
  padding: 0 16px;
  resize: vertical;
`

type PropertyFieldProps<
  V extends string | number = any,
  O = (e: React.ChangeEvent<{ value: V }>) => void
> = {
  label?: string
  labelProps?: Parameters<typeof PropertyFieldLabel>[0]
  wrapperProps?: Parameters<typeof PropertyFieldWrapper>[0]
  onChange: O
  InputComponent?: React.FC<{ value: V; onChange: O } & { [key: string]: any }>
  value: V
  children: never
}

export const SimplePropertyField: React.FC<PropertyFieldProps> = ({
  label,
  labelProps,
  InputComponent = StringInput,
  wrapperProps,
  ...props
}) => {
  return (
    <PropertyFieldWrapper {...wrapperProps}>
      {label && (
        <PropertyFieldLabel {...labelProps}>{label}</PropertyFieldLabel>
      )}
      <PropertyFieldInputWrapper>
        <InputComponent {...props} />
      </PropertyFieldInputWrapper>
    </PropertyFieldWrapper>
  )
}
